export type InfoCustomerServiceAction =
  | { type: 'SET_IS_FETCHING_CUSTOMERSERVICE_CONTENT' }
  | { type: 'SET_FETCH_CUSTOMERSERVICE_CONTENT_FAILED' }
  | { type: 'SET_CUSTOMERSERVICE_CONTENT', content: Julius.Website.ServicePageViewModel };

  export const setIsFetching = (): InfoCustomerServiceAction => ({
    type: 'SET_IS_FETCHING_CUSTOMERSERVICE_CONTENT',
  });

  export const setFetchFailed = (): InfoCustomerServiceAction => ({
    type: 'SET_FETCH_CUSTOMERSERVICE_CONTENT_FAILED',
  });

  export const setCustomerServiceContent = (content: Julius.Website.ServicePageViewModel): InfoCustomerServiceAction => ({
    content,
    type: 'SET_CUSTOMERSERVICE_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/Redux/actions.tsx